var React = require('react');

function CartAdd (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 5h2.458a2 2 0 011.934 1.491l1.846 7.018A2 2 0 009.172 15h8.786a2 2 0 001.884-1.33L21 10.414","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("circle",{"cx":"18","cy":"19.5","r":"2.5","fill":"currentColor","key":1}),React.createElement("circle",{"cx":"10","cy":"19.5","r":"2.5","fill":"currentColor","key":2}),React.createElement("path",{"d":"M14 0v10M19 5H9","stroke":"currentColor","strokeWidth":"2","key":3})]);
}

CartAdd.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = CartAdd;

CartAdd.default = CartAdd;
